export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9393.ac546c5f.jpg";